import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

import { Reconnecting } from "views/Reconnecting";

/**
 * Wrapper component for routes that can be accessed regardless of authentication state.
 *
 * This component checks the global authentication state:
 * - If `isLoggedIn` is "yes" or "no", the user is allowed to access the nested route(s) via <Outlet />.
 * - If the authentication state is still unknown (before the refresh token validation completes),
 *   it renders the <Reconnecting /> placeholder while determining the user's login status.
 *
 * Typically used for signup or trial flows where a user may be logged out or already logged in,
 * and we want to allow creating a new account with the same email.
 */
export const PrivateOrPublicRoute = () => {
  const { isLoggedIn } = useSelector((state) => state.authentication);

  if (isLoggedIn === "yes" || isLoggedIn === "no") {
    return <Outlet />;
  } else {
    return <Reconnecting />;
  }
};
